import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCancelPushNotification,
  usePushNotificationById,
} from "../../../api/notification/use-push-notification-detail";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";
import Modal from "../../../components/ui/Modal/Modal";
import Tabs, { Tablist } from "../../../components/ui/Tabs/Tabs";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import Stats from "./Section/Stats";
import EditShipping from "./Section/EditShipping";

const tabs = [
  {
    title: "수동 발송",
    id: 1,
  },
  {
    title: "푸시알림 발송 리스트",
    id: 2,
  },
];

function PushNotificationDetailPage() {
  const [currentTab, _setCurrentTab] = React.useState(2);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = usePushNotificationById(id);
  const notificationData = data?.data;
  const { mutate: cancelPushNotification } = useCancelPushNotification(id);

  const onChangeTab = (id) => {
    if (id === 1) navigate("/push-notification");
  };

  const handleBackToList = () => {
    navigate("/push-notification");
    localStorage.setItem("selectedTab", "2");
  };

  const handleEdit = () => {
    setIsEditMode(true);
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
  };

  const onCancelNotification = async () => {
    await cancelPushNotification(id);
  };

  return (
    <>
      <div>
        <TitlePage
          title="푸시알림 발송
"
        />
        <Tabs
          onChangeTab={onChangeTab}
          currentTab={currentTab}
          tabs={tabs}
          tabWidth="px-4"
          titleTabPosition="justify-center"
          marginTop="mt-[24px]"
        >
          <Tablist currentTab={currentTab} index={1}>
            {/* <ManualShipping /> */}
          </Tablist>
          <Tablist currentTab={currentTab} index={2}>
            <div className="font-bold mb-4 text-[14px]">
              푸시알림 발송 리스트 {">"} 발송내역 상세
            </div>
            <Stats data={notificationData} />
            {isEditMode ? (
              <EditShipping
                setIsEditMode={setIsEditMode}
                id={id}
                defaultValue={notificationData}
              />
            ) : (
              <div>
                <div className="mt-8 flex items-center">
                  <div className="w-1/2">
                    <FieldBox splitted label="발송 유형">
                      <span className="p-2">
                        {notificationData?.isImmediate === true
                          ? "즉시 발송"
                          : "예약 발송"}
                      </span>
                    </FieldBox>
                  </div>
                  <div className="w-1/2">
                    <FieldBox splitted label="발송 상태">
                      <span
                        className={`p-2 ${
                          notificationData?.isSent === false &&
                          notificationData?.isCanceled === false
                            ? "text-[#e80000]"
                            : ""
                        }`}
                      >
                        {notificationData?.isSent === true
                          ? "발송 완료"
                          : "발송 예약 대기"}
                      </span>
                    </FieldBox>
                  </div>
                </div>
                <FieldBox padding="p-0" label="발송 대상">
                  <div className="py-2 px-4">
                    {notificationData?.receivers?.length === 0
                      ? "전체 병원회원"
                      : "지정 병원회원"}
                    {notificationData?.receivers?.length > 0 ? (
                      <span className="text-[#e80000] font-bold">
                        &nbsp; &nbsp; 발송 대상 : 총{" "}
                        {notificationData?.receivers?.length}명
                      </span>
                    ) : (
                      <span className="text-[#e80000] font-bold">
                        &nbsp; &nbsp; 발송 대상 : 총 1명
                      </span>
                    )}
                  </div>
                  {notificationData?.receivers?.length === 0 ? null : (
                    <div className="border-t border-primary-grey py-2 px-4">
                      {notificationData?.receivers?.map((res, index) => {
                        return (
                          <span>
                            {res?.hospital?.email}
                            {index < notificationData?.receivers?.length - 1
                              ? ", "
                              : ""}
                          </span>
                        );
                      })}
                    </div>
                  )}
                </FieldBox>
                <FieldBox
                  label={`제목 (${notificationData?.title?.length}/40)`}
                >
                  <span className="p-2">{notificationData?.title}</span>
                </FieldBox>
                <FieldBox
                  label={`내용 (${notificationData?.content?.length}/500)`}
                >
                  <div className="p-2 min-h-[100px]">
                    {notificationData?.content}
                  </div>
                </FieldBox>
                <FieldBox isLast label="연결 외부 URL">
                  <div className="p-2">
                    {notificationData?.externalLink ?? "없음"}
                  </div>
                </FieldBox>
              </div>
            )}
          </Tablist>
        </Tabs>
      </div>
      <div className="mt-[30px] flex justify-center">
        {isEditMode ? null : (
          <>
            <Button
              onClick={handleBackToList}
              className="py-[8.5px]"
              text="목록"
            />
            {notificationData?.status === "PENDING" &&
            notificationData?.isCanceled === false ? (
              <>
                <Button
                  onClick={handleEdit}
                  className="py-[8.5px]"
                  text="발송 정보 변경"
                />
                <Modal
                  description={
                    <span>
                      해당 예약 발송을 '발송취소' 하시겠습니까? '발송 예약 대기'
                      상태에서만 <br />
                      취소가 가능하고, 해당 푸시알림은 발송되지 않습니다.
                    </span>
                  }
                  bgSubmit="bg-[#a30000]"
                  cancelText="닫기"
                  submitText="발송취소"
                  onSubmit={onCancelNotification}
                >
                  <Button
                    className="py-[8.5px] text-white"
                    bgColor="bg-[#a30000]"
                    borderColor="border-[#a30000] border"
                    text="발송취소"
                  />
                </Modal>
              </>
            ) : null}
          </>
        )}
      </div>
    </>
  );
}

export default PushNotificationDetailPage;
